import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JarwisService {

  private baseUrl = environment.BaseUrlAPI + "/api";

  constructor(private http: HttpClient) { }

  login(data){
    return this.http.post(`${this.baseUrl}/login`, data);
  }
  sendPasswordResetLink(data){
  	return this.http.post(`${this.baseUrl}/sendPasswordResetLink`, data);
  }
  changePassword(data){
  	return this.http.post(`${this.baseUrl}/resetPassword`, data);
  }

  //для изменения пароля из настроек юзера
  changePasswordInside(data){
    console.log('data',data);
    return this.http.post(`${this.baseUrl}/resetPasswordInside`, data);
  }
}
